var permissions = []
var user = {}
if (localStorage.getItem('permissions')) {
  permissions = localStorage.getItem('permissions')
  user = JSON.parse(localStorage.getItem('user'))
}
var authRoute = [{
  type: 'tree',
  icon: 'fa fa-dashboard',
  name: 'Dashboard',
  router: {
    name: 'Dashboard'
  }
}]

// ============================ Master ==============================
var master = {
  type: 'tree',
  icon: 'fa fa-plus-square',
  name: 'Master',
  items: []
}
// ============================ LoanPlan ==============================
if (permissions.includes('loan-plan-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Loan Plan',
    router: {
      name: 'loanplan'
    }
  })
}
if (permissions.includes('collection-center-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Groups',
    router: {
      name: 'group'
    }
  })
}
if (permissions.includes('state-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'State',
    router: {
      name: 'State'
    }
  })
}

if (permissions.includes('bank-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Bank',
    router: {
      name: 'bank'
    }
  })
}
if (permissions.includes('leave-type-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Leave',
    router: {
      name: 'leave'
    }
  })
}
if (permissions.includes('branch-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Branches',
    router: {
      name: 'branches'
    }
  })
}
if (permissions.includes('series-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Series',
    router: {
      name: 'series'
    }
  })
}
if (permissions.includes('leave-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Leave',
    router: {
      name: 'leave'
    }
  })
}
if (permissions.includes('designation-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Designation',
    router: {
      name: 'designation'
    }
  })
}
if (permissions.includes('relation-create') || permissions.includes('reason-create') || permissions.includes('identity-proof-create') || permissions.includes('purpose-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Miscellaneous',
    router: {
      name: 'mixed'
    }
  })
}
// ============================ Software Timing ==============================
if (permissions.includes('software-timing-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Software Timing',
    router: {
      name: 'softwareTiming'
    }
  })
}
if (permissions.includes('Setting-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Setting',
    router: {
      name: 'setting'
    }
  })
}
if (permissions.includes('bank-create')) {
  master.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Session',
    router: {
      name: 'sessionMaster'
    }
  })
}
if (permissions.includes('state-create') || permissions.includes('designation-create') || permissions.includes('series-create') || permissions.includes('leave-create') || permissions.includes('bank-create') || permissions.includes('relation-create') || permissions.includes('reason-create') || permissions.includes('identity-proof-create') || permissions.includes('purpose-create') || permissions.includes('loan-plan-create') || permissions.includes('software-timing-create')) {
  if (user.type === 'member') {

  } else {
    authRoute.push(master)
  }
}

// ============================ HRM ==============================
var hrm = {
  type: 'tree',
  icon: 'fa fa-id-card',
  name: 'HRM',
  items: []
}
if (permissions.includes('staff-create')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Employee',
    router: {
      name: 'employee'
    }
  })
}
if (permissions.includes('salary-disbursement-create')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Salary',
    router: {
      name: 'salary'
    }
  })
}
if (permissions.includes('holiday-create')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Holiday',
    router: {
      name: 'holiday'
    }
  })
}
if (permissions.includes('employee-transfer-create')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Employee Transfer',
    router: {
      name: 'employeetransfer'
    }
  })
}
if (permissions.includes('employee-transfer-create')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Member Transfer',
    router: {
      name: 'employeemembertransfer'
    }
  })
}
if (permissions.includes('update-center-leader-create')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Update Center Leader',
    router: {
      name: 'updatecenterleader'
    }
  })
}
if (permissions.includes('staff-create')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Print Letter',
    router: {
      name: 'printemployeeletters'
    }
  })
}
if (permissions.includes('employee-Leave-view-any')) {
  hrm.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Employee Leave',
    router: {
      name: 'employeeleave'
    }
  })
}
hrm.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Attendance',
  router: {
    name: 'attendance'
  }
})
/*
hrm.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Employee Salary Details',
  router: {
    name: 'employeesalarydetail'
  }
})
hrm.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Employee Absent Detail',
  router: {
    name: 'employeeabsentdetail'
  }
})
*/
if (permissions.includes('holiday-create') || permissions.includes('staff-create') || permissions.includes('update-center-leader-create') || permissions.includes('employee-transfer-create')) {
  if (user.type === 'member') {

  } else {
    authRoute.push(hrm)
  }
}

// ============================ Member ==============================
var member = {
  type: 'tree',
  icon: 'fa fa-users',
  name: 'Members',
  items: []
}
if (permissions.includes('member-view-any')) {
  member.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Members',
    router: {
      name: 'customer'
    }
  })
}
if (permissions.includes('collection-center-member-create')) {
  member.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Member Group',
    router: {
      name: 'customergroup'
    }
  })
}
if (permissions.includes('collection-center-member-view-any') || permissions.includes('member-view-any')) {
  authRoute.push(member)
}

// ============================ Create Loan =========================
var createLoan = {
  type: 'tree',
  icon: 'fa fa-credit-card',
  name: 'Create Loan',
  items: []
}
if (permissions.includes('loan-disbursement-view-any')) {
  createLoan.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Download Loan Form',
    router: {
      name: 'downloadloanform'
    }
  })
}
if (permissions.includes('loan-disbursement-view-any')) {
  createLoan.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Individual Loan',
    router: {
      name: 'individualLoan'
    }
  })
}
if (permissions.includes('loan-disbursement-view-any')) {
  createLoan.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Group Loan',
    router: {
      name: 'groupLoan'
    }
  })
}
if (permissions.includes('loan-disbursement-view-any')) {
  authRoute.push(createLoan)
}

// ============================ Disbursment List =========================
var disbursement = {
  type: 'tree',
  icon: 'fa fa-tasks',
  name: 'Disbursement',
  items: []
}
if (permissions.includes('loan-disbursement-view-any')) {
  disbursement.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Disbursed',
    router: {
      name: 'disbursment'
    }
  })
}
if (permissions.includes('loan-disbursement-view-any')) {
  disbursement.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Group Disbursed',
    router: {
      name: 'groupMemberDisbursment'
    }
  })
}
// if (permissions.includes('loan-disbursement-view-any')) {
//   disbursement.items.push({
//     type: 'item',
//     icon: 'fa fa-circle-o',
//     name: 'Group Disbursed',
//     router: {
//       name: 'groupDisbursment'
//     }
//   })
// }
if (permissions.includes('loan-disbursement-view-any')) {
  if (user.type === 'member') {

  } else {
    authRoute.push(disbursement)
  }
}
// ============================ Loan ==============================
// if (permissions.includes('loan-disbursement-view-any')) {
//   authRoute.push({
//     type: 'item',
//     icon: 'fa fa-money',
//     name: 'Create/Disbursment Loan',
//     router: {
//       name: 'loan'
//     }
//   })
// }

// ============================ showCollection ==============================
if (permissions.includes('member-collection-view-any')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-leanpub',
    name: 'Loan Summary',
    router: {
      name: 'loanSummary'
    }
  })
}

// ============================ Collection ==============================
var paymentCollection = {
  type: 'tree',
  icon: 'fa fa-money',
  name: 'EMI Records',
  items: []
}
if (permissions.includes('member-collection-view-any')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Paid EMIs',
    router: {
      name: 'showCollection'
    }
  })
}
if (permissions.includes('member-collection-view-any')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Due EMIs',
    router: {
      name: 'emiCollection'
    }
  })
}
if (permissions.includes('promisetopay-view')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-thumbs-up',
    name: 'Promise To Pay',
    router: {
      name: 'promisetopay'
    }
  })
}
if (permissions.includes('member-collection-create')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Group EMI Collection',
    router: {
      name: 'groupEmiCollection'
    }
  })
}
if (permissions.includes('member-collection-create')) {
  paymentCollection.items.push({
    type: 'item',
    icon: 'fa fa-inr',
    name: 'Member Collection',
    router: {
      name: 'memberCollection'
    }
  })
}
if (permissions.includes('member-collection-view-any')) {
  authRoute.push(paymentCollection)
}

// ============================ Approvals ==============================
var approval = {
  type: 'tree',
  icon: 'fa fa-check-square-o',
  name: 'Approvals',
  items: []
}
if (permissions.includes('salary-disbursement-approve')) {
  approval.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Salary',
    router: {
      name: 'approvesalary'
    }
  })
}
if (permissions.includes('member-collection-approve')) {
  approval.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Collection',
    router: {
      name: 'collection'
    }
  })
}
if (permissions.includes('sattlement-approve')) {
  approval.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Settlement',
    router: {
      name: 'approveSettlement'
    }
  })
}
if (permissions.includes('member-collection-approve') || permissions.includes('sattlement-approve') || permissions.includes('salary-disbursement-approve')) {
  authRoute.push(approval)
}
// ============================ Entry ==============================
var entity = {
  type: 'tree',
  icon: 'fa fa-desktop',
  name: 'Settlements',
  items: []
}
if (permissions.includes('sattlement-create')) {
  entity.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Settlement',
    router: {
      name: 'settlement'
    }
  })
}
if (permissions.includes('death-member-view-any')) {
  entity.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Death Member List',
    router: {
      name: 'deathMember'
    }
  })
}
if (permissions.includes('sattlement-create') || permissions.includes('death-member-view-any')) {
  authRoute.push(entity)
}

// ============================ CIBIL API ==============================
if (permissions.includes('member-collection-delete')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-black-tie',
    name: 'CIBIL',
    router: {
      name: 'cibil'
    }
  })
}

// ============================ ACCOUNTING ==============================
if (permissions.includes('voucher-create')) {
  authRoute.push({
    type: 'item',
    isHeader: true,
    name: 'ACCOUNTING'
  })
}

// ============================ Voucher ==============================
var voucher = {
  type: 'tree',
  icon: 'fa fa-pencil-square-o',
  name: 'Voucher',
  items: []
}
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Day Book',
  router: {
    name: 'daybook'
  }
})
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Voucher Entries',
  router: {
    name: 'voucher'
  }
})
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Payment',
  router: {
    name: 'paymentvoucher'
  }
})
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Receipt',
  router: {
    name: 'receiptvoucher'
  }
})
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Contra',
  router: {
    name: 'contravoucher'
  }
})
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Journal',
  router: {
    name: 'journalvoucher'
  }
})
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'Trial Balance',
  router: {
    name: 'trailbalance'
  }
})
voucher.items.push({
  type: 'item',
  icon: 'fa fa-circle-o',
  name: 'FY Opening Balance',
  router: {
    name: 'FYOpeningBalance'
  }
})
if (permissions.includes('voucher-create')) {
  authRoute.push(voucher)
}

// ============================ ACGroup ==============================
if (permissions.includes('group-create')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-address-book',
    name: 'ACGroup',
    router: {
      name: 'acgroup'
    }
  })
}
// ============================ Ledger ==============================
if (permissions.includes('ledger-create')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-book',
    name: 'Ledger',
    router: {
      name: 'ledger'
    }
  })
}
// ============================ Branch Ledger ==============================
if (permissions.includes('branch-ledger-create')) {
  authRoute.push({
    type: 'item',
    icon: 'fa fa-book',
    name: 'Branch Ledger',
    router: {
      name: 'branchLedger'
    }
  })
}

// ============================ REPORTING HEADER ==============================
if (permissions.includes('role-permission-view-any')) {
  authRoute.push({
    type: 'item',
    isHeader: true,
    name: 'REPORTING'
  })
}
// ============================ Reporting ================================
var reporting = {
  type: 'tree',
  icon: 'fa fa-file',
  name: 'Reporting',
  items: []
}
if (permissions.includes('member-collection-approve')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Due EMI Reporting',
    router: {
      name: 'DueEmiReport'
    }
  })
}
if (permissions.includes('member-collection-approve')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Collection Reporting',
    router: {
      name: 'CollectionReport'
    }
  })
}
if (permissions.includes('member-collection-approve')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Disbursement Reporting',
    router: {
      name: 'DisbursementReport'
    }
  })
}
if (permissions.includes('member-collection-approve')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Member Attendance',
    router: {
      name: 'memberemipaymentattendance'
    }
  })
}
if (permissions.includes('member-collection-approve')) {
  reporting.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Online Payment Reporting',
    router: {
      name: 'OnlinePaymentReport'
    }
  })
}
if (permissions.includes('member-collection-approve')) {
  authRoute.push(reporting)
}
// ============================ PERMISSION ==============================
if (permissions.includes('role-permission-view-any')) {
  authRoute.push({
    type: 'item',
    isHeader: true,
    name: 'PERMISSION'
  })
}

// ============================ Role & Permission ==============================
var rolePermission = {
  type: 'tree',
  icon: 'fa fa-desktop',
  name: 'Role & Permission',
  items: []
}
if (permissions.includes('role-permission-view-any')) {
  rolePermission.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Permission',
    router: {
      name: 'permission'
    }
  })
}
if (permissions.includes('role-view-any')) {
  rolePermission.items.push({
    type: 'item',
    icon: 'fa fa-circle-o',
    name: 'Role',
    router: {
      name: 'role'
    }
  })
}
if (permissions.includes('role-view-any') || permissions.includes('role-permission-view-any')) {
  authRoute.push(rolePermission)
}

module.exports = authRoute



// WEBPACK FOOTER //
// ./src/lib/slideMenuItems.js